import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {outlinedChip} from "@/styles/receipes/outlined_chip";

import {HomeMatchFinancingPreference} from "../../constants/preferences/home_match_preferences_values";

interface IProps {
    isSelected: boolean;
    label: string;
    onSelect: () => void;
    value: HomeMatchFinancingPreference;
}

export const HomeMatchPreferencesWizardFinancingOption = (props: IProps) => {
    const {isSelected, label, onSelect, value} = props;
    const id = `home-match-preferences-wizard-financing-${value}`;

    return (
        <label className={isSelected ? optionSelectedStyle : optionStyle} data-selected={isSelected ? "" : undefined} htmlFor={id}>
            <input checked={isSelected} className={inputStyle} id={id} name="financing" onChange={onSelect} type="radio" value={value} />

            <span className={checkSlotStyle}>
                <CheckIcon className={checkIconStyle} fill="var(--colors-white)" />
            </span>

            <Text
                as="span"
                className={optionTextStyle}
                color={isSelected ? "var(--colors-white)" : "var(--colors-secondary)"}
                preserveFontSize
                variant="info_txt_1"
            >
                {label}
            </Text>
        </label>
    );
};

const optionLayout = css.raw(outlinedChip, {
    alignItems: "center",
    cursor: "pointer",
    display: "inline-flex",
    height: "4.8rem",
    minWidth: "10rem",
    position: "relative",
    transition: "background-color 200ms ease, border-color 200ms ease",
    "&:has(input:focus-visible)": {
        outline: "0.2rem solid var(--colors-info)",
        outlineOffset: "0.2rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const optionStyle = css(optionLayout);

const optionSelectedStyle = css(optionLayout, {
    backgroundColor: "var(--colors-secondary)"
});

const optionTextStyle = css({
    alignItems: "center",
    display: "flex",
    transition: "color 200ms ease",

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const inputStyle = css({
    border: "none",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    p: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
});

const checkSlotStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    marginRight: 0,
    minWidth: 0,
    opacity: 0,
    overflow: "hidden",
    transition: "width 200ms ease, margin-right 200ms ease, opacity 200ms ease",
    width: 0,

    "[data-selected] &": {
        marginRight: 1,
        opacity: 1,
        width: "1.6rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const checkIconStyle = css({
    flexShrink: 0,
    height: "1.6rem",
    transform: "none",
    width: "1.6rem"
});
import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {outlinedChip} from "@/styles/receipes/outlined_chip";

import {HomeMatchFinancingPreference} from "../../constants/preferences/home_match_preferences_values";

interface IProps {
    isSelected: boolean;
    label: string;
    onSelect: () => void;
    value: HomeMatchFinancingPreference;
}

export const HomeMatchPreferencesWizardFinancingOption = (props: IProps) => {
    const {isSelected, label, onSelect, value} = props;
    const id = `home-match-preferences-wizard-financing-${value}`;

    return (
        <label className={isSelected ? optionSelectedStyle : optionStyle} data-selected={isSelected ? "" : undefined} htmlFor={id}>
            <input checked={isSelected} className={inputStyle} id={id} name="financing" onChange={onSelect} type="radio" value={value} />

            <span className={checkSlotStyle}>
                <CheckIcon className={checkIconStyle} fill="var(--colors-white)" />
            </span>

            <Text
                as="span"
                className={optionTextStyle}
                color={isSelected ? "var(--colors-white)" : "var(--colors-secondary)"}
                preserveFontSize
                variant="info_txt_1"
            >
                {label}
            </Text>
        </label>
    );
};

const optionLayout = css.raw(outlinedChip, {
    alignItems: "center",
    cursor: "pointer",
    display: "inline-flex",
    height: "4.8rem",
    minWidth: "10rem",
    position: "relative",
    transition: "background-color 200ms ease, border-color 200ms ease",
    "&:has(input:focus-visible)": {
        outline: "0.2rem solid var(--colors-info)",
        outlineOffset: "0.2rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const optionStyle = css(optionLayout);

const optionSelectedStyle = css(optionLayout, {
    backgroundColor: "var(--colors-secondary)"
});

const optionTextStyle = css({
    alignItems: "center",
    display: "flex",
    transition: "color 200ms ease",

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const inputStyle = css({
    border: "none",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    p: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
});

const checkSlotStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    marginRight: 0,
    minWidth: 0,
    opacity: 0,
    overflow: "hidden",
    transition: "width 200ms ease, margin-right 200ms ease, opacity 200ms ease",
    width: 0,

    "[data-selected] &": {
        marginRight: 1,
        opacity: 1,
        width: "1.6rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const checkIconStyle = css({
    flexShrink: 0,
    height: "1.6rem",
    transform: "none",
    width: "1.6rem"
});
